// English多語言
const en = {
    _code: "Code",
    _name: "Name",
    _cost: "Cost",
    _member: "Member",
    _vendor: "Vendor",
    _inventory: "Inventory",
    _discount: "Discount",
    _user: "User",
    _shop_and_station: "Shop & Station",
    _base_setup: "Base Setup",
    _wechat_report_manager: "WeChat Customer Report Management",
    _wechat_report_auth: "WeChat Report Authorization",
    _user_maintenance: "User Maintenance",
    _search: "Search",
    _reset: "Reset",
    _edit: "Edit",
    _askdelete: "Are You Sure To Delete ?",
    _delete_ok: "Delete Success",
    _exit: "Exit",
    _save: "Save",
    _delete_fail: "Deletion Fail",
    _connect_hq_failed: "Connect to Hq Failure",
    _not_allow_empty: "Does not allow empty",
    _connecting: "Connecting Server,please Wait...",
    _plesase_wait: "Please Wait ...",
    _login: "Login",
    _password: "Password",
    _user_name: "User name",
    _login_password_error: "Invalid Password",
    _connect_database_failed: "Connect To Database Failure",
    _select_please: "Please Select",
    _void_by: "Void",
    _edit_by: "Edit",
    _create_by: "Create",
    _void_date: "Void Date",
    _edit_date: "Edit Date",
    _create_date: "Create Date",
    _role_list: "Role List",
    _recall: "Recall",
    _back: "Back",
    _super_admin: "Super admin",
    _errtitle: "System Error",
    _btn_close: "Close",
    _err_code: "Error Code",
    _err_message: "Error Message",
    _err_prog: "Error Prog",
    _cfm_title: "Comfirm Dialog",
    _cfm_msg: "Click Yes to continue, Click No to cancel.",
    _cfm_btnyes: "Yes",
    _yes_msg: "Success!",
    _err_prog_msg: "System Error",
    _dele: "Delete",
    _role: "Role",
    _current_user: "Current user",
    _success: "Success",
    _failure: "Failure",
    _home_page: "Home page",
    _navigation_menu: "Navigation menu",
    _lbl_lock: "Lock Column",
    _chk_show_deleted: "Show Deleted Record",
    _username: "User Name",
    _user_password: "User Password",
    _show_all_menu: "Show All Menu",
    _show_authorized_menu: "Only Show Authorized Menu",
    _reprot_menu_option: "Report Menu Option",
    _search_other_shop: "Search Other Shop",
    _confirm_cardno: "Confirm Card No. Password",
    _comfirm_password: "Confimr User Password",
    _full_name: "Full Name",
    _user_role: "User Role",
    _language: "Language",
    _max_discount_rate: "Max Discount Rate",
    _salesman: "Salesman",
    _cardno: "Card No",
    _auto_exit: "Auto Exit After Finished",
    _hq: "HQ",
    _fore_sales: "Sales",
    _report_center: "Report Center",
    _shop: "Shop",
    _askrecall: "Are you sure to recall?",
    _recall_success: "Recall success",
    _suspend: "Suspend",
    _addr: "Address",
    _district: "District",
    _country: "Country",
    _shopgroup: "Shop Group",
    _tel: "Tel",
    _fax: "Fax",
    _contactperson: "Contact Person",
    _switch_tn: "Issue Tn For Other Shops",
    _switch_ii: "Input Purchase For Other Shops",
    _switch_ord: "Input Order Item For Other Shops",
    _switch_adj: "Change Qty For Other Shops",
    _switch_sto: "Issue Stock Take For Other Shops",
    _instant_sales: "Instant Sales",
    _dummy_shop: "Dummy Shop",
    _delivery_time: "Delivery Time",
    _monday: "Monday",
    _tuesday: "Tuesday",
    _thursday: "Thursday",
    _friday: "Friday",
    _saturday: "Saturday",
    _sunday: "Sunday",
    _holiday: "Holiday",
    _wednesday: "Wednesday",
    _allow: "Allow",
    _execute: "Run",
    _export: "Export",
    _import: "Import",
    _print: "Print",
    _email: "Email",
    _commit: "Commit",
    _edit_not_allow: "The Record Is Already Deleted. Edit Does Not Allowed",
    _operating_time: "Operating time",
    _operating_type: "Operating type",
    _old_data: "Old data",
    _new_data: "New data",
    _field_name: "field name",
    _loading_old_data: "loading old data",
    _role_access: "Role Access",
    _view: "View",
    _content: "Content",
    _fr_inv: "Create Invoice",
    _view_historical_records: "View Historical Records",
    _exit_system: "Exit System",
    _do_not_input_same_code: "Do not input same code",
    _role_no_access: "No Access!",
    _verify_password_err: "Invalid Password Or Card No !",
    _access_validate: "Access Validate",
    _access_authorize: "Access Authorize",
    _yes: "Yes",
    _no: "No",
    _not_found: "Record Not Found !!",
    _user_type: "User Type",
    _copy: "Copy",
    _role_copy: "Role Copy",
    _to: "to",
    _limit: "Limit",
    _check_role: "The below role are wrong,please check!",
    _win_title: "Proan Computer-Rms8",
    _template: "template",
    _ip_limit: "IP limit.You can not access the system on this computer.",
    _qty: "Qty",
    _repeat: "Repeat",
    _format_error: "Format error",
    _select_all: "Select All",
    _add_tips: "Click to add a new item.",
    _user_info: "User Info",
    _login_count: "Login Count",
    _pre_login_time: "Pre-login Time",
    _pre_lout_time: "Pre-lout Time",
    _login_info: "Login Info",
    _user_detail_info: "User Detail Info",
    _change_pwd: "Change Password",
    _delete_not_allow: "Delete Not Allowed",
    _dl_plugin: "Click here download plugin",
    _role_delete: "Delete failed. The role contains user(s)",
    _old_pwd: "Old Password",
    _new_pwd: "New Password",
    _confirm_new_pwd: "Confirm Password",
    _login_time: "Login Time",
    _sys_setup: "System Setup",
    __coupen_need_open: "Need to pay the button independently",
    _coupen_need_open: "Need to pay the button independently",
    _station_function: "Staion Function",
    _station_hardware: "Staion Hardware",
    _userinfo: "User Information",
    _station: "Station",
    _mac_address: "MAC Address",
    _report_xr_cross: "User List",
    _uom: "Uom",
    _station_name: "Station Name",
    _unit: "Unit",
    _per: "Per",
    _save_success: "Save Success!",
    _business_section: "Section",
    _section: "Section",
    _rollback: "Rollback",
    _shop_list: "Shop List",
    _no_of_period: "No. Of Section",
    _cancel: "Cancel",
    _has_save_setting: "Has Save Success",
    _save_system_seting_failed: "Save System Seting Failed",
    _has_copy: "Has Copy",
    _copy_success: "Copy sucess",
    _copy_Failed: "Copy Failed",
    _percentage: "Percentage",
    _lookup: "Look up",
    _pk_not_found: "Primary Key Not Found",
    _operation: "Operation",
    _normal_credit_card: "Normal Credit Card",
    _cup: "China UnionPay",
    _quick_pass_macau: "Quick Pass (Macau)",
    _vendor_maintenance: "Vendor Maintenance",
    _payway: "Payway",
    _d_add: "Delivery address",
    _salute: "Salute",
    _effective_section: "Effective Section",
    _chk_using: "Using",
    _using: "Using",
    _mustinput: "Must have a value",
    _start_time: "Start Time",
    _end_time: "End Time",
    _include_shop: "Include Shop",
    _exclude_shop: "Exclude Shop",
    _payway_type: "Payway Type",
    _ecr: "Extra Charge",
    _pay_days: "Pay Days",
    _cur_sign: "Currency  Sign",
    _open_drawer: "Open Drawer",
    _no_decimal_places: "No Decimal Places",
    _input_cardno: "Input Cardno",
    _additional_fee_type: "Additional Fee Type",
    _additional_fee_rate: "Additional Fee Rate",
    _sales_type: "Sales Type",
    _traditional: "Traditional",
    _simplified: "Simplified",
    _item_cn: "Chinese Order",
    _item_en: "English Order",
    _inv_cn: "Chinese Invoice",
    _inv_en: "Eng Invoice",
    _sitem: "Set Item",
    _recipe: "Recipe",
    _item_pole_display: "Pole Display",
    _new_item_as: "New item as",
    _kitchen_order: "Kitchen Order",
    _days: "Days",
    _currency_rate: "Currency Rate",
    _ecr_id: "ECR Machine",
    _ecr_detail_sub_id: "ECR Pay Type",
    _catery: "Catery",
    _subcate: "Subcate",
    _brand: "Brand",
    _outlet_color: "Outlet Color",
    _pplcnt: "pplcnt",
    _tax: "Tax",
    _askppl: "askppl",
    _auto_disc: "Auto Disc",
    _level_disc_add: "level disc add",
    _no_using: "No Using",
    _custom: "Custom",
    _order: "Order",
    _chinese: "Chinese",
    _english: "English",
    _print_maintenance: "Print maintenance",
    _dishes_cate: "Dishes Catery",
    _exit_to_system: "Are You Sure To Exit ?",
    _printer_name: "Printer Name",
    _printer_backup: "Backup Printer",
    _printer_group: "Group Printer",
    _ask_exit_system: "Are you sure want to exit system",
    _printer: "Printer",
    _to_printer_name: "To Printer Name",
    _print_mode: "Print Mode",
    _split: "Split",
    _outlet: "Outlet",
    _diff_print: "Choose a different printer",
    item_is_using_not_delete: "Item is using, do not delete",
    _each_dish_type: "Each dish type",
    _each_piece_of_food: "Each piece of food",
    _type: "Type",
    _clear_one: "Clear one",
    _clear_all: "Clear all",
    _menu_dishe_cate: "Menu dishe cate",
    _show_history_holiday: "Show History Holiday",
    _holiday_to: "Holiday To",
    _next_step: "Next step",
    _year: "Year",
    _back_step: "Back step",
    _album_maintenance: "album maintenance",
    _album: "album",
    _current_position: "Current position",
    _replace: "Replace",
    _upload_success: "Upload Success",
    _list: "List",
    _image: "Image",
    _system: "System",
    _upload_fail: "Upload Fail",
    _will_also_delete_the_pictures_in_the_album: "Will also delete the pictures in the album",
    _exist_continue: "already exist, do you want to continue",
    _item_transfer: "Item Transfer",
    _date_from: "Date From",
    _date_to: "Date To",
    _shop_from: "Shop From",
    _shop_to: "Shop To",
    _doc_adj: "Qty Adjust",
    _transfer_note: "Transfer Note",
    _from_shop: "From Shop",
    _to_shop: "To Shop",
    _date: "Date",
    _reason: "Reason",
    _committed_date: "Committed Date",
    _item_code: "Item Code",
    _item_name: "Item Name",
    _amount: "Amount",
    _exist_qty: "Exist qty",
    _copy_and_new: "Copy And New",
    _belong_date: "Belong Date",
    _warning: "Warning",
    _dishes_setup: "Dishes Setup",
    _dishes: "Dishes",
    _item: "Item",
    _file_code: "File Code",
    _item_not_found: "Item Not Found",
    _start_time_cost: "Start time cost",
    _the_net_cost: "The net cost",
    _final_entry_cost: "Final entry cost",
    _by_min: "By Min",
    _lowest: "lowest",
    _order_qty: "Order Qty",
    _total: "Total",
    _already_exists: "Already Exists",
    _not_enough: "Not Enough",
    _item_transfer_reason: "Item Transfer Reason",
    _doc_adj_reason: "Qty Adjust reason",
    _network_error: "Network Error",
    _please_contact_administrator: "Please Contact Administrator",
    _detailed_information: "Detailed information",
    _price: "Price",
    _only_for_following_login: "only for following {0} login",
    _please_input: "Please input",
    _purchase_order: "Purchase order",
    _time_manage: "Time Manage",
    _active: "Active",
    _daily: "Daily",
    _weekly: "Weekly",
    _monthly: "Monthly",
    _reverse_selection: "Reverse Selection",
    _value: "Value",
    _effective_date: "Effective Date",
    _expiring_date: "Expiring Date",
    _time: "Time",
    _advanced_setting: "Advanced Setting",
    _expand: "Expand",
    _collapse: "Collapse",
    _all: "All",
    _special: "Special",
    _adaptation: "Adaptation",
    _group: "Group",
    _total_amount: "Total Amount",
    _shop_code: "Shop Code",
    _vendor_code: "Vendor Code",
    _vendor_name: "Vendor Name",
    _join: "Join",
    _current: "Current",
    _new: "New",
    _add: "Add",
    _multi_select_dishes: "Multi Select Dishes",
    _other_options: "Other Options",
    _copy_to_another_name: "Copy To Another Name",
    _link_ppl: "And the number of associations",
    _show_in_order: "Show in order",
    _multi_choise: "Multiple choise",
    _show_in_report: "Show in report",
    _multi_qty: "Multiple qty",
    _cust_modi: "Custom modifier",
    _top_dispord: "To dispord",
    _ppl: "Guest(s)",
    _special_price: "Special treatment amount",
    _special_percentage: "Special treatment percentage",
    _ordinary_special_treatment: "Ordinary special treatment",
    _ask_for_special_treatment: "Ask for special treatment",
    _desc_kit: "Other languages",
    _modi_cate: "Special treatment in kind",
    _Ingredients_increase: "Ingredients increase",
    _sort: "Sort",
    _modifier: "Modifier",
    _dishes_level: "Deshes Level",
    _disc_cate: "Disc Cate",
    _color: "Color",
    _min_amt: "Consumption amount",
    _duty_free: "Duty free",
    _effective_time: "Effective time",
    _time_type: "Time Type",
    _ascending: "Ascending",
    _descending: "Descending",
    _disc_dishes_level: "disc dishes level",
    _disc_sys_user: "Effective user",
    _level_combination: "Level (A) + Level (B) --> Level (B) Price",
    _item_level_rule: "Item Level Rule",
    _a_item_level_id: "Item Leve (A)",
    _b_item_level_id: "Item Leve (B)",
    _rule_type: "Rule Type",
    _a_and_b: "In A and B, the point of time in the entry into force",
    _a_or_b: "A or B one of the points within the effective time of the point of the application",
    _suspended: "Suspended",
    _must: "Must",
    _general: "General",
    _to_the_top: "To The Top",
    _to_the_bottom: "To The Bottom",
    _callup: "Call Up",
    _keyboard: "Keyboard",
    _remin: "Reminder",
    _print_inv: "Print Invoice",
    _table_no: "TableNo",
    _invitem: "Item",
    _outstanding: "Outstanding",
    _credit_card_no: "Credit Card No.",
    _sub_total: "Sub Total",
    _rounding: "Rounding",
    _table_new: "New Table",
    _message: "Message",
    _line: "Line",
    _generate_combo_package: "Generate combo package",
    _xdisc: "Group Discount",
    _points_redemption: "Points Redemption ",
    _sell_perqty: "Can sell quantity ",
    _modifier_soldout: "Modifier Sold Out",
    _delay_print: "Delay Print",
    _enter: "Enter",
    _Warehouse: "Warehouse",
    _select_more: "Select More",
    _discount_list: "Discount list",
    _history: "Operational history",
    _today: "Today",
    _three_days_a: "Three Days A",
    _three_days_later: "Three days later",
    _change_ppl: "Change Cover",
    _member_disc: "Member Discount",
    _takeout_pickup: "Takeout Pickup",
    _lock_and_unlock: "Lock and unlock",
    _instant_cuisine: "Instant Cuisine",
    _new_temp_table: "New Temp Table",
    _view_carte: "View Carte",
    _remove_temp_table: "Remove Temp Table",
    _associate_table: "Associate Table",
    _travel_amt: "Amount",
    _book_table: "Book Table",
    _sales_amount: "Sales Amount",
    _dishes_order_color: "Dishes Color And Order",
    _display_mode: "Display Mode",
    _formmodicolor: "Modifier Color & Display Order",
    _check_turn_table: "Check Turntable Case",
    _service_charge_setup: "Service Charge Setup",
    _print_eng_dish_paper: "Print English Dish paper",
    _coupon: "Coupon",
    _modifier_setup: "Modifier Setup",
    _seafood_brand: "Seafood Brand",
    _check_warehoused: "Check Warehoused",
    _dishes_inventory: "Dishes and Inventory",
    _prepare_checkout: "Prepare Checkout",
    _relogin: "Relogin",
    _main_window: "to Main",
    _area: "Area",
    _sub_area: "Sub area",
    _save_message: "Save Message",
    _show_all: "Show All",
    _are_you_sure: "Are You Sure To Save?",
    _delete_area: "Delete area and related data",
    _delete_sub_area: "Delete sub area and related data",
    _printer_no: "Printer ID",
    _printer_node: "Printer Node",
    _default_printer_id: "Default Printer ID",
    _file_type: "File Type",
    _status: "Status",
    _print_date: "Ptint Date",
    _threed_run: "Threed Run",
    _TRACE_NOT_FOUND: "TRACE NOT FOUND",
    _setting_new_table_button: "Show New Table Button",
    _trace_fail: "trace fail",
    _wait_trace: "Waiting for the transaction",
    _transaction_completion: "Transaction completion",
    _terminal_busy: "terminal busy",
    _local_currency: "Local Currency",
    _setting_order: "Order Setting ",
    _setting_oncall_ask_qty: "Ask for Call-Up Item Quantity Upon Call Up",
    _or: "Or",
    _reverse: "Reverse",
    _show_checked_only: "Show Checked Only",
    _available_modifier_list: "Available Modifier List",
    _selected_modifier_list: "Selected Modifier List",
    _use_range: "use range",
    _min_currency_unit: "min currency unit",
    _more: "More",
    _sale: "Sale",
    _purchase: "Purchase",
    _payway_detail: "Payway Detail",
    _department: "Department",
    _background: "Background",
    _table: "Table",
    _restaurant: "Restaurant",
    _printer_setup: "Printer Setup",
    _order_outlet: "Order Outlet",
    _change_printer_area: "Change Printing Area",
    _can_not_repeat: "Can not repeat",
    _are_you_sure_to_delete: "Are You Sure To Delete The {0} ?",
    _rule: "Rule",
    _dishes_modifier: "Dishes Modifier",
    _check_time: "Check Time",
    _select: "Select",
    _department_breakdown: "Department Breakdown",
    _function: "Function",
    _split_table: "Split Table",
    _pay: "Pay",
    _change_table: "Change Table",
    _order_slip: "Order Slip",
    _split_order: "Split Order",
    _take_away: "Take Away",
    _menu: "Menu",
    _one: "One",
    _change: "Change",
    _missing: "Missing",
    _send_order: "Send Order",
    _invoice: "Invoice",
    _period_all: "Period/All",
    _sold_out_message: "Sold Out Message",
    _show_void_item: "Show Void Item",
    _item_discount: "Item Discount",
    _cancel_group_discount: "Cancel Group Discount",
    _svr_charge: "Service Charge",
    _printer_forward_setup: "Printer Forward Setup",
    _srv_free: "No Service Charge",
    _input_soldout_msg: "Input Soldout Message",
    _change_dept_price: "Change Dept Price",
    _discount_entire_receipt: "Discount Entire Receipt",
    _invoiceno: "Invoice No",
    _tips: "Tips",
    _invoice_amt: "Invoice Amount",
    _itemno: "Item No",
    _item_desc: "Item Desc",
    _order_time: "Order Time",
    _wait_time: "Wait Time",
    _waiter: "Waiter",
    _callqty: "Call Qty",
    _are_you_sure_changetable: "Are You Sure To Change Table?",
    _last_setting_name: "Last Setting",
    _allow_to: "Allow To {0}",
    _handwriting_item: "Handwriting Item",
    _required_item: "Required Item",
    _check_when_receipt_printed: "Check When Receipt Printed",
    _times_no_of_guests: "Times No. of Guests",
    _ask_qty: "Ask Qty",
    _ask_price: "Ask Price",
    _default_hold: "Default Hold",
    _apply_dayend_analysis: "Apply Dayend Analysis",
    _include_in_min_charge: "Include In Min Charge",
    _custom_item: "Custom Item",
    _keep_name: "Keep Name",
    _no_print_invoice_when_zero: "No Print Invoice When Zero",
    _can_do: "Allow",
    _select_print_area: "Select Print Area",
    _correct: "Correct",
    _blank_key: "Blank Key",
    _upper: "Upper",
    _lower: "Lower",
    _dishes_print_is_refused: "The Following Dishes Amount Is Zero Which Print IsRefused",
    _is_defa: "Menber Defa Type",
    _price_lv: "Menber Price Lv",
    _allow_all_pb: "All Price Book",
    _allow_all_mm: "All Mix & Match",
    _birth_add_points: "Add Points in Birthday",
    _amt_ceiling: "Amount Ceiling",
    _perc: "Regular Item Discount",
    _perc_disc_item: "Discounted Item Discount",
    _member_type: "Member Type",
    _cannot_change_empty_table: "Can Not Change A Empty Table",
    _duplicate_disCount: "Duplicate Discount, Continue Anyways?",
    _expiry_time: "Expiry Time",
    _item_cannot_discounted: "Item Cannot Be Discounted!",
    _cln_type: "Cleaning Type",
    _by_station: "By Station",
    _by_user: "By User",
    _receipt_printer: "Receipt Printer",
    _exception: "Exception",
    _select_void_reason: "Please Select Void Reason",
    _are_you_sure_delete: "Fonfirm Remove Selected Items?",
    _remain_qty: "Remain Qty",
    _qty_per_section: "Qty Per Section",
    _warning_qty: "Warning Qty",
    _is_limit_sell: "Is Limit Sell",
    _calculate_by_kilo: "Calculate By Kilo",
    _calculate_by_hectogram: "Calculate By Hectogram",
    _total_item_net_amount: "Total Item Net Amount",
    _netamt: "Net Amt.",
    _no_record_will_be_save: "No Record Will Be Save",
    _octopus_put_card: "PLEASE PUT ON OCTOPUS CARD",
    _octopus_rw_100021: "Invalid Octopus, Please Contact MTR Customer Service Centre",
    _octopus_rw_100022_l1: "+++ Do Not Cancel The Txn +++",
    _octopus_file_gen: "Gen. Octopus Files Success",
    _octopus_init_100001: "Mop Connection Failure",
    _octopus_init_100005: "Mop Connection Failure",
    _octopus_init_100101: "Failed To Create Ar(save Log)",
    _octopus_init_100102: "Failed To Create Ud(save Log)",
    _octopus_init_100099: "Firmware Upgrade Has Performed Due To Housekeeping()",
    _octopus_rw_100001: "Mop Connection Failure",
    _octopus_rw_100005: "Mop Connection Failure",
    _octopus_rw_100016: "Read Card Error, Retry Please",
    _octopus_rw_poll_100017: "Read Card Error, Retry Please",
    _octopus_rw_deduct_100017: "Read Card Error, Retry Please",
    _octopus_rw_100017: "Read Card Error, Retry Please",
    _octopus_rw_100034: "Read Card Error, Retry Please",
    _octopus_rw_100020: "Present Card Again",
    _octopus_rw_100022: "Incomplete Transaction,retry Please",
    _octopus_rw_100023: "Transaction Log Full",
    _octopus_rw_100032: "Present Card Again",
    _octopus_rw_100048: "Insufficient Value",
    _octopus_rw_100049: "Stored Value Exceed Limit",
    _octopus_error: "Error",
    _octopus_starting_please_wait: "Mop Is Starting, Please Wait ... ... ...",
    _octopus_init_again_please_wait: "Mop Is Checking, Please Wait ... ... ...",
    _octopus_rw_100057: "Retail Limit Exceeded",
    _octopus_rw_100025: "Incomplete Transaction,retry Please",
    _octopus_rw_100022_retry: "Retry Please (octopus No.",
    _octopus_can_not_use_select_other_payment: "Can''t Use Octopus, Please Select Other Payment Method",
    _octopus_rw_same_card_retry: "Incorrect Card, Retry Please ( Octopus No.",
    _octopus_re_connct_are_you_sure: "Re-connect To Mop, Are You Sure ?",
    _octopus_it_may_take_1_or_2_minute: "It Will Take 1 To 2 Minutes",
    _octopus_card_adult: "Adult",
    _octopus_card_student: "Student",
    _octopus_card_child: "Child",
    _octopus_card_elder: "Elder",
    _octopus_card_personalized: "Personalized",
    _octopus_rw_100019: "Invalid Card",
    _octopus_add_value_exceed_limited: "Stored Value Exceed Limited.",
    _octopus_deduction_value_exceed_limited: "Deduction Value Exceed Limited.",
    _octopus_rw_100024: "Invalid Card",
    _octopus_rw_100051: "Invalid Pos Controller Id",
    _octopus_add_value_can_not_void: "Octopus Add Value, Cannot Void The Invoice",
    _octopus_add_value_can_not_edit: "Octopus Add Value, Cannot Edit The Invoice",
    _octopus_change_to_cash: "When Void Will Change To [ Cash ]",
    _octopus_print_remain: "Remaining Value",
    _octopus_print_cardno: "Octopus No.",
    _octopus_print_device: "Device No.",
    _octopus_print_payment: "Octopus payment",
    _octopus_rw_100022_l2: "Transaction Incomplete",
    _octopus_rw_100022_l3: "Please Request Customer To Present The Same Card Again To Complete The Transaction",
    _time_comparison: "The end time must be greater than the start time",
    _diff_time: "Time overlap",
    _not_found_file: "File Not Found.",
    _database_name: "Database Name",
    _cover: "Guest(s)",
    _include_all_shop: "( * = Include All Shop )",
    _exclude_all_shop: "( * = Exclude All Shop )",
    _price_level: "Price Level",
    _level: "Level",
    _kit_order_print_ppl: "Print Number of Guests on Kitchen Order Slip",
    _kit_print_item_amount: "Print Prices on Kitchen Order Slip",
    _kitchen_order_slip_content: "Kitchen Order Slip Contents",
    _kit_print_order: "Kitchen Order Slip Content Sort Order",
    _kit_modi_print_langue: "Modifier Print Details",
    _notify_kit_when_void_item: "Notify Kitchen When Item Cancelled",
    _notify_kit_when_move_table: "Notify Kitchen When Changing Tables",
    _print_to_kitchen: "Print to Kitchen",
    _kit_print_item_code: "Print Item Code on Kitchen Order Slip",
    _void_item_all_in_one: "Cancel dishes are all dishes of a single",
    _table_move_print_item: "Print Items When Changing Tables",
    _sitem_print_add_line: "Print Set Meal (Combo) Divider Line",
    _password_expiration_days: "Password Expiration Days",
    _can_not_same_as_recent_use: "Can not be the same as your recent use",
    _expired: "Expired",
    _password_rules: "Password rules",
    _whether_freeze_password: "Whether to freeze the password",
    _freezing_minutes: "Freezing minutes",
    _please_change_password: "Please change your password as soon as possible",
    _already_frozen_log_after: "Already frozen, please log in after {0} minutes",
    _cash_pay: "Cash Payment",
    _retry: "Retry",
    _unselect_all: "Unselect All",
    _sell: "Sell",
    _octopus_com_port: "Octopus Com Port",
    _setting_kit: "print_setup",
    _octopus_have_display: "Octopus Device Have Display",
    _octopus_baud_rate: "Octopus Baud Rate",
    _octopus: "Octopus",
    _setting_table_setup: "Dine In Mode",
    _table_flash_having_unfinish: "Tables Flashes When Table has Unfinished Items",
    _table_can_chg_diff_outlet: "Allow Table Change to Different Outlet",
    _direct_pay_mode: "Direct Payment Mode",
    _octopus_loc_id: "Octopus Location ID",
    _void_item_ask_reason: "Ask for Reason When Cancelling Ordered Items",
    _change_price_after_printed: "Do Not Allow Price Change After Order Sent to Kit",
    _can_sell_sellout_item: "Allow Selling of Sold-Out Items",
    _click_item_red_flash: "Display Flashing Red Border as Reminder to Choose",
    _modi_item_allow_neg: "Allow Item Price to be Negative Amt",
    _crashier_auto_exit: "Automatically Close Receipt Paid Screen (Seconds)",
    _crashier_preview_inv: "Preview Invoice in Payment Screen",
    _disc_srv: "Is Service Charge Discountable",
    _table_show_big: "Table Magnification Ratio",
    _copy_station: "Copy Station",
    _input_sequence: "Input Sequence",
    _previous_page: "Previous Page",
    _group_by_item_order_by_amt: "Group By Item Order By Amt",
    _next_page: "Next Page",
    _group_by_item_order_by_qty: "Group By Item Order By Qty",
    _group_by_item_order_by_item: "Group By Item Order By Item",
    _void_reason: "Void Reason",
    _entire_system: "Entire System",
    _outlet_mode: "Outlet Mode",
    _cln_cash_in_reason: "Cln Cash In Reason",
    _cln_cash_out_reason: "Cln Cash Out Reason",
    _kitchen: "Kitchen",
    _chinese_englisth: "Chinese+Kitchen",
    _chinese_english_kitchen: "Chinese+English+Kitchen",
    _other_langue: "Other Langue",
    _chinese_other_langue: "Chinese Other Langue",
    _english_other_langue: "English Other Langue",
    _kit_other_langue: "Kit+Other Langue",
    _chinese_english_other_langue: "Chinese+English+Other Langue",
    _chinese_kitchen: "Chinese+Kitchen",
    _english_kitchen: "english+kitchen",
    _join_print_inv: "Join Print Inv",
    _floor_plan_mode: "Floor Plan Mode",
    _simple_mode: "Simple Mode",
    _keyboard_input_qty: "Keyboard input Qty",
    _about: "About",
    _invoice_print_in_fastfood: "Print Invoice in Fastfood Mode",
    _inv_qty_for_fastfood: "Set Number of Invoices to Print in Fastfood Mode",
    _fastfood_askno: "Input Number of Guests in Fastfood Mode",
    _fastfood_need_remark: "Enter Remarks in Fastfood Mode",
    _auto_askno_begin: "Start Number for Auto-numbering",
    _auto_askno_end: "End Number for Auto-numbering",
    _fastfood_choose_outlet: "Fast food model can choose the outlet",
    _fastfood_can_only_save: "Allow Append Items in Fastfood Mode",
    _fastfood_split_print: "Does the fast food mode have a single print function",
    _auto_askno_ab: "Automatic call number AB is selected",
    _askno_auto_reset: "Reset to Start Number Each Day",
    _cashier: "Cashier",
    _invno: "Receipt No.",
    _seattime: "Arrival Time",
    _amtperhead: "Amount Per Guest",
    _scriber: "Please Sign",
    _use: "Use",
    _sit: "Sit",
    _printed: "Printed",
    _clear: "Clear",
    _lock: "Lock",
    _table_clearing: "Table Being Cleaned",
    _continue_anyway: "Are You Sure You Want To Continue?",
    _is_require_qty: "Ask For Qty",
    _dedu_srv: "Whether to hedge service charges",
    _fast_food_mode: "Fastfood Mode",
    _inv_setup: "Print Inv Setup",
    _setting_email: "email setting",
    _pay_slip_setting: "Pay Slip",
    _paylist_print_ntime: "Number of paper printing",
    _octoups_print_paylist: "The octopus payment is printed paper buried feet",
    _print_slip_setting: "Slip_Setting",
    _print_slip: "Print Order Slip",
    _fastfood_print_slip: "Print Order Slip in Fastfood Mode",
    _turn_to_page: "Turn To Page",
    _page: "Page",
    _maintenance: "Maintenance",
    _manage: "Manage",
    _tables: "Tables",
    _height: "Height",
    _width: "Width",
    _foreColor: "ForeColor ",
    _confirm: "Confirm",
    _upload: "Upload",
    _setup: "Setup",
    _prompt: "Prompt",
    _remark: "Remark",
    _file_does_not_exist: "file does not exist",
    _over_maximum_gust_amount: "Over Maximum Gust Amount",
    _receipt_printed: "Receipt Printed",
    _cannot_change_table: "Cannot Change Table",
    _send_reminder: "Are You Sure You Want To Send A Reminder?",
    _step: "Step {0}",
    _from: "From",
    _change_table_coanot_be_undone: "Changing Tables Cannot Be Undone",
    _cannot_change_be_diff_outlet: "Cannot Change Tables Between Diffrent Outlet",
    _printed_cannot_continu: "Receipt Printed, Cannot Continu!",
    _not_set: "Not Set",
    _cateries: "Cateries",
    _remin_time: "Reminder",
    _paidtime: "Paid Time",
    _inv_print_addition_header: "Print Amount Slip with Invoice",
    _print_perhead: "Print Amount Per Guest",
    _inv_print_itemcode: "invoice print Item Code",
    _max_ppl: "Maximum Number of Guests per Table",
    _inv_remark: "Invoice Remark",
    _not_allow_zero: "The Number Must Be Greater Than Zero!",
    _printed_item_notallow_up_qty: "Cannot Increase Qty After Sent To Kitchen",
    _cleaning_table_reset_time: "Cleaning Tables Buffer Time (Minutes)",
    _disc_not_active: "Discount Is Inactive, Please Check Settings",
    _item_level_disc_disable: "The Discount Isn't Valid For This Item's Level",
    _pricebook: "Price Book",
    _as_discount: "As Discount",
    _data_already_exists: "Data already exists",
    _fix_price_qty: "Fix price and qty",
    _default_item: "Default Item",
    _have_no_right: "You Have No Right",
    _please_contact_with_admin: "Please Contact With Administrator",
    _askno_ppl: "Call No./Guest(s)",
    _askno: "Call No.",
    _itemlist: "Item List",
    _inv_amt: "Receipt Amount",
    _paid_amt: "Paid Amount",
    _change_price: "Change Price",
    _payment_slip: "Payment Slip",
    _dept_analyse: "Dept Analysis",
    _reprint_inv_dntpay: "DUPLICATE RECEIPT",
    _slip_printer: "Order Slip Printer",
    _inv_printer: "Invoice Printer",
    _station_setup: "Station setup",
    _input_askno: "Please Input Askno",
    _input_remark: "Please Input Remark",
    _copy_shop: "Copy Shop",
    _email_smtp: "SMTP",
    _email_user_password: "Password",
    _email_port: "Email Port",
    _email_method: "Send Email Program",
    _email_co: "Email From",
    _email_format: "Attachment Format",
    _email_user_name: "User Name",
    _print_pay_slip: "Print Payment Receipt",
    _modifier_list: "Modifier list",
    _is_allow_tips: "Allow Tips",
    _exchange: "Exchange",
    _outletsrv: "Outletsrv",
    _tick_will_be_added_to_dishes_in_menu: "Tick, dishes will be added to the kinds of dishes in menu; cancel the tick will remove all the price of the kinds in menu",
    _all_time: "All time",
    _click_delete_will_remove_menu_under_dishes: "Click delete, Will remove the current menu under the corresponding types of dishes",
    _tick_will_add_dishes_cate_in_menu: "Tick, will add dishes cate in the menu, cancel the tick will be removed the dishes cate in the menu. Click Add Dishes will add dishes in the dishes cate; click delete and will delete the dishes in the dishes cate.",
    _tick_on_the_appropriate_line: "Please tick on the appropriate line",
    _differ_time: "Time Difference",
    _voidtime: "Void Time",
    _tables_information_management: "Tables information management",
    _select_background_image: "Select Background Image",
    _background_image: "Background Image",
    _system_image: "System Image",
    _custom_image: "Custom Image",
    _upload_imagge: "Upload imagge",
    _self_order: "Self order",
    _please_input_item_code: "Please input item code",
    _search_by_itemno: "Search by itemno",
    _set_table: "Set Table",
    _undecided_dishes: "Undecided dishes",
    _please_input_qty: "Please input qty",
    _no_found: "No found",
    _delete_octopus_tips: "Not allowed to delete the octopus",
    _please_select_menu: "Please select menu and press 'Yes' button",
    _this_table_is_locked: "This table is Locked",
    _has_been_sold_out_cannot_order: "Has been sold out,Cannot order",
    _has_been_sold_out_can_order: "Has been sold out, Can order",
    _select_target_table: "Please select target table",
    _send_order_success: "Send order success",
    _tables_can_chg_after_print: "Allow Table Change after Invoice Printed",
    _direct_pay_show_inv: "Show Invoice before Direct Pay",
    _hide_main_table: "Does the sub station interface hide the main table(As empty)",
    _sit_overtime: "Extensive Stay Notice (Minutes)",
    _sit_deadtime: "Extensive Stay Notice (Minutes)",
    _content_repeat_re_input: "input the content repeat, please re-input",
    _active_time: "Active Time",
    _re_play: "Re_play",
    _select_please_color: "Please Select Color",
    _checked_table: "Checked Table",
    _dishes_code: "Dishes Code",
    _can_only_choose_one: "Can Only Choose One of Them",
    _custom_color: "Custom Color",
    _apply_custom_color: "Apply Custom Color",
    _copy_color_to_items_with_same_catery: "Copy Color To Items With Same Catery",
    _change_no: "Change No",
    _insert_blank: "Insert Row	1",
    _remove_blank: "Remove Blank Row",
    _effective_section_must_cover_24_hours: "Effective Section Must Cover 24 Hours",
    _all_cash: "All Cash",
    _card_no: "Card No.",
    _should_change: "Should Change",
    _tables_pplcnt_notallow_zero: "Cannot Change No. of Guests To 0!",
    _auto_number: "Auto Number",
    _all_shop: "All Shop",
    _please_correct_the_pay_amount: "Please Correct Payment Amount",
    _please_input_amount: "Please input amount",
    _please_input_change: "Please input change",
    _cannot_further_split_table: "Cannot Further Split Table",
    _please_input_no: "Please Input No, of Guests",
    _please_input_cutom_discount_amount: "Please Input Custom Discount Amount",
    _please_input_price_per_unit: "Please Input Price Per Unit",
    _cannot_increase_qty: "Cannot Increase  Qty After Sent To Kitchen",
    _item_show_descen: "Does the menu item display both in English and Chinese",
    _item_colsint: "Item Column Spacing",
    _modi_large_gui: "Enlarge Modifier Interface",
    _item_lines: "Item Rows",
    _item_cols: "Item Columns",
    _modi_fontsize: "Modifier Font Size",
    _modi_panel_backcolor: "Modifier Interface Background Color",
    _cate_fontsize: "Item Catery Font Size",
    _cate_panel_backcolor: "Item Catery Background Color",
    _cate_lines: "Print Free (No Charge) Modifiers",
    _orderlist_backcolor: "Menu interface background color",
    _item_selected_color: "Order Entry Item Selected Color",
    _order_lines: "Order Entry Rows",
    _modi_lines: "No. of Modifier Rows to Show",
    _modi_cols: "Modifier Columns",
    _modi_lineint: "Modifier Row Spacing",
    _modi_colsint: "Modifier Column Spacing",
    _cate_lineint: "Print Set Meal (Combo) Details",
    _cate_colsint: "Item Catery Column Spacing",
    _order_lineint: "Order Entry Row Spacing",
    _disp_item_id: "Display Item ID during Order Entry",
    _cate_cols: "Item Catery Columns",
    _item_fontsize: "Item Font Size",
    _item_panel_backcolor: "Item Background Color",
    _order_item_fontsize: "Order Item FontSize",
    _item_lineint: "Item Row Spacing",
    _color_setup: "User interface setup",
    _modifier_color_setup: "Modifier Color & Order",
    _brow_level_item: "Browse Items in Current Level",
    _please_select_printer_language: "Please Select Printer Language",
    _select_language: " Select  Language",
    _select_at_least_one: "Select at least one",
    _please_select_system_language: "Please Select System Language",
    _table_setup: "Table Setup",
    _local_report: "Local Report",
    _dishes_list: "Dishes List",
    _hide: "Hide",
    _kit: "Kit",
    _kit_cancel: "Kit Cancel",
    _kit_remind: "Kit Remind",
    _kit_take_away: "Kit Take Away",
    _kit_change_table: "Kit Change Table",
    _inv_dine_in: "Inv (Dine In)",
    _inv_take_away: "Inv (Take Away)",
    _pay_slip_dine_in: "Pay Slip (Dine In)",
    _addition_header: "Addition Header",
    _pay_slip_take_away: "Pay Slip Take Away",
    _slip: "Slip",
    _report_sourece: "Report Sourece",
    _dishes_combo: "Dishes Combo",
    _cannot_move_table_in_use: "You Cannot Move a Table In Use",
    _tableno_not_found: "Table No Not Found",
    _are_you_suret_remove_this_table: "Are You Sure You Want To Delete This Table?",
    _add_new_page: "Add New Page",
    _fastfood_info: "Fastfood info",
    _cln_report: "Cleaning Report",
    _paid_analyse: "Paid Analysis",
    _outlet_analyse: "Outlet Analysis",
    _item_analyse: "Item Analysis",
    _section_analyse: "Section Analyse",
    _printed_item_move: "Printed_item_move",
    _report_type: "Report Type",
    _invoice_list: "Invoice List",
    _cln_no: "Cln No.",
    _void_item: "Voided Item",
    _refresh_data: "Refresh Data",
    _display_cancel_report: "Display Cancel Report",
    _modify_invoice: "Modify Invoice",
    _modify_pay_slip: "Modify Pay Slip",
    _modify_table_slip: "Modify Table Slip",
    _modify_kit: "Modify Kit",
    _modify_addition_header: "Modify Addition Header",
    _modify_cln_report: "Modify Cln Report",
    _select_report_file: "Select Report File",
    _times: "Times",
    _title: "Title",
    _send_email: "Send Email",
    _email_to: "Email To",
    _email_cc: "Email CC",
    _no_srv_amt: "No Service Amount",
    _end: "End",
    _disc_analyse: "Disc. Analysis",
    _orgamt: "Org Amt",
    _expense_amount: "Expense Amount",
    _cash_amt: "Cash Amount",
    _inv_qty: "No. of Receipt",
    _cust_qty: "Guest(s)",
    _amtperorder: "Amount Per Order",
    _discamt: "Discount Amount",
    _total_tips: "Total Tips",
    _opening_cash: "Opening Cash",
    _spectra: "Spectra",
    _cash_drawer: "Cash Drawer",
    _cash_drawer_com_port: "Cash Drawer Com Port",
    _cash_drawer_baud_rate: "Cash Drawer Baud Rate",
    _is_visible: "Visible",
    _cash_drawer_data_bits: "Cash Drawer Data Bits",
    _spectra_com_port: "Spectra Data Bits",
    _yes_no: "Yes/no",
    _invoice_info: "Invoice Infomation",
    _display_order: "Display Order",
    _report_path_not_found: "Report path not found",
    _reprint_report: "Reprint Report",
    _inv_printing: "Print Receipt Details",
    _dept_printing: "Print Department Sales Analysis",
    _disc_after_inv: "Disc after print inv",
    _sending_mail: "Sending mail,please Wait...",
    _inv_prined: "Receipt was Printed",
    _calc_with_org_price: "Calc Based on Original Price",
    _calc_with_act_price: "Calc Based on Actual Price",
    _title_length: "Title length must be greater than one",
    _date_range: "Date Range",
    _cln_date: "Cln Date",
    _cln_data: "Cln Data",
    _closing_include: "Closing Includes:",
    _cash_in: "Cash In",
    _edit_table: "Edit Table",
    _remove_table: "Remove Table",
    _opening_cash_detail: "Opening Cash Detail",
    _move_table: "Move Table",
    _save_setting: "Save Setting",
    _page_manage: "Page Manage",
    _set_backundimage: "Set Background Image",
    _sales: "Sales",
    _report_daily: "Report Daily",
    _invalid_date: "Invalid Date",
    _select_first: "Select {0} First",
    _edit_report: "Edit Report",
    _same_lang: "Sync Description",
    _show_cashier: "Show Cashier When More Than One",
    _actual_price: "Based On Actual Price",
    _show_items_whith_price_zero: "Show Items With a Price of Zero In Dayend Analysis Report",
    _disc_after_print_inv: "Disc After Print Inv",
    _hourly_sales_amount: "Hourly Sales Amount",
    _the_details_invoice_of_discount: "The Details Invoice Of Discount",
    _item_set_price: "Add Price When Under A Set",
    _receipt_price_changed: "Receipt Price Changed",
    _showitem_with_zero: "Show Items with a Price of Zero in Dayend Analysis Report",
    _no_disc_points_card: "No Discount Card Points Card",
    _modify_payment_slip: "Modify Payment Slip",
    _modify_slip: "Modify Slip",
    _modify_kitchen_order: "Modify Kitchen Order",
    _share_order: "Split Order",
    _call_item: "Call-Up Items",
    _check_choiced_item: "Check Choiced Item",
    _ask_discount_reason: "Ask for Discount Reason",
    _table_add_cleaning_status: "Add Cleaning Status for Tables",
    _disc_reason: "Discount Reason",
    _order_ingredient_option: "Please Select An Action!",
    _select_modifier: "Select Modifier",
    _table_no_order_nochange: "Cannot Change a Table With No Items Selected",
    _table_nouse_nochange: "Cannot Change an Empty Table",
    _input_qty: "Please Input Custom Discount Qty",
    _min_charge: "Minimum Charge",
    _invinfo_show_amt: "Inv Info Show Amt",
    _do_clean_table_must_empty: "All Tables Must be Cleared Before Close-Out	",
    _print_itemlist_in_pay_slip: "Print Item List on Payment Receipt",
    _slip_print_adduser_time: "Print User and Time on Payment Receipt",
    _paylist_print_table_name: "Print Table Name on Payment Receipt",
    _paylist_print_inv_header: "Print Invoice Header on Payment Receipt",
    _pay_slip_print_disc: "Print Discount Total on Payment Receipt",
    _round_to_dollar: "Round to Dollar",
    _round_to_10cents: "Round to 10 Cents",
    _more_to_dollar: "More to Dollar",
    _less_to_dollar: "Less to Dollar",
    _round_to_cents: "Round to Cents",
    _more_to_5cents: "More to 5 Cents",
    _less_to_5cents: "Less to 5 Cents",
    _more_to_50cents: "More to 50 Cents",
    _less_to_50cents: "Less to 50 Cents",
    _no_change: "No Change",
    _input_call_num: "Please Input Call-Up Qty",
    _call_qty_larger_than_qty: "Call-Up Qty Cannot Exceed Ordered Qty",
    _allcall: "Call-Up All Items Now",
    _guests: "Guests",
    _itemcode: "Item Code",
    _cmd_ok: "Ok (\<o)",
    _table_booking: "Table Booking",
    _day_before: "The Day Before",
    _day_after: "The Day After Today",
    _date_selection: "Select Date",
    _current_date: "Current Date",
    _skip: "Move",
    _table_clear: "Empty Table",
    _table_notfound: "Table No. Not Found !",
    _language_select: "Select Language",
    _sys_message: "System Message",
    _dayend: "Dayend",
    _clean_reprint: "Reprint Closing",
    _delete_invoice: "Void Invoice",
    _reprint: "Reprint",
    _reset_qty: "Reset Qty",
    _invalid: "Invalid",
    _backgrounf_image: "Background Image",
    _square: "Square",
    _seat_qty: "Seat Qty",
    _table_no_of: "No. Of Table",
    _per_table: "Per Table",
    _per_head: "Per Head",
    _big_table_name: "Table Name Display Magnification",
    _cleaned: "Checked Amount",
    _non_cleaned: "Non-Closed Amt",
    _datetype: "Date Type",
    _dayend_include: "Dayend Report Includes",
    _preview: "Preview",
    _date_time: "Date time",
    _octopus_no: "Octopus No.",
    _last_add_value_by_cash: "Last add value by Cash on {0}",
    _if_you_have_any_queries_on_transaction: "if you have any queries on the above transaction, please keep the receipt and call Octopus Customer Service Hotline at 2266 2222.",
    _add_table_by_no: "Add New Table By Number",
    _inv_void: "Are You Sure You Want To Void The Receipt?",
    _drink_qty: "Drink Qty",
    _level_cannot_same: "Level Cannot Be The Same",
    _level_rule_error: "Level Rule Defination Error",
    _table_have_unfinish_item: "Cannot Print Receipt - Table Has Outstanding Items",
    _invalid_char: "Invalid Character, Please Input Again",
    _change_price_no_level_disc: "Change Price No Level Disc, Continue?",
    _select_none: "Clear All",
    _allow_to_sell: "Allow To Sell",
    _dishes_price: "Dishes Price",
    _copy_to: "Copy To",
    _select_one: "One",
    _backspace: "Backspace",
    _do_clean_table_must_unused: "Please Clear All Tables Before Closing Out!",
    _table_printed_nochange: "Receipt Printed, Cannot Change Table!",
    _linkppl_modi_change_ppl_inside: "Has linkppl Modi , Please Change PPl Inside.",
    _sts_message: "System Message",
    _enter_sale_info: "Enter Sale Info",
    _input_code_or_plus: "Input Item Code Or + To Change Qty",
    _cln: "Clean",
    _ok: "Ok",
    _waitor: "Waitor",
    _void_time: "Void Time",
    _table_notallow_lock: "The Table Is In Use, Cannot Lock!",
    _no_unlock_link_inv_table: "Not Allowed To Unlock The Table When Invoice Has Been Printed",
    _soldout_dishes: "SoldOut Dishes",
    _item_split: "Item Split",
    _share_order_done: "Order Has Been Split, You Must Delete the Split Out Order Before Edit",
    _order_split_not_finish: "Incomplete Item Split Operation !",
    _table_is_locked: "Table Is Locked, Please Unlock It!",
    _valid: "Valid",
    _waiting_time: "Waiting Time",
    _nitem_onlysave_not_printed: "Items Will Be Saved And Will Not Print To Kitchen, Continue Anyway?",
    _table_noorder_noslip: "Empty Order, Cannot Print Order Slip!",
    _outlet_info_no_exist: "Outlet Info Does Not Exist, Please Maintain The Outlet Info First.",
    _tables_page_not_exist: "Tables Page Not Exist , Please Maintain Page First",
    _outlet_shop_not_exist: "Outlet Shop Not Exist",
    _task_queue: "Task Queuing",
    _order_func: "Order Function",
    _table_func: "Table Function",
    _can_only_add_one_take_away: "Can Only add One of take away type",
    _expiration_date_can_not_less_than_effective_date: "Expiration Date Can Not Less Than Effective Date",
    _empty_section: "Empty Section",
    _exclude_sitem: "Exclude Set Item",
    _split_package_sub_item: "Split Package Sub Item",
    _sub_table_full: "Cannot Split More Than 15 Tables",
    _delete_take_away_tips: "Not allowed to delete the Take Away",
    _cash_bf: "Cash Behind",
    _cash_out: "Cash Out",
    _chkdept_printing: "Dept Printing",
    _chkhourly_sales_amount: "Hourly Sales Amount",
    _show_all_items: "Show All Items",
    _show_all_dishescate: "All Dishes Cate",
    _receipt: "Receipt",
    _other_receipt: "Other Receipt",
    _other_slip: "Other Slip",
    _copy_and_add: "Copy And Add",
    _include: "Include",
    _exclude: "Exclude",
    _clear_input: "Clear",
    _service_charge_multiple: "Service charge multiple",
    _current_shop: "Current Shop",
    _current_station: "Current Station",
    _inv_chs: "Simple Invoice",
    _inv_cht: "Traditional Invoice",
    _input: "Input",
    _srv_charge: "Service Charge",
    _payment_slip_eng: "EnglishPayment Slip",
    _payment_slip_cht: "Traditional Payment Slip",
    _payment_slip_chs: "Simple Payment Slip",
    _table_noorder_nopay: "Empty Order, Cannot Settle!",
    _cancel_share_order: "Cancel Share Order",
    _select_discreason: "Please Choose Reason For Discount",
    _disc_amount: "Discount Amount",
    _unit_price: "Unit Price",
    _unit_price_and_modi_amount: "Unit Price+Modi Amount",
    _kit_item_amt_showtype: "Print Prices on Kitchen Order Slip",
    _default_printer: "Default Printer",
    _printer_paper_problem: "Paper Problem",
    _out_of_tonner: "Out Of Toner",
    _printer_not_available: "Is not available",
    _printer_out_of_memory: "Is out of memory",
    _printer_paper_jam: "Has a paper jam",
    _printer_paused: "Is paused",
    _printer_low_on_toner: "Is low on toner",
    _printer_off_line: "Is off line",
    _printer_error_state: "Is in an error state",
    _printer_user_intervention: "Needs user intervention",
    _printer_full_output_bin: "Has a full output bin",
    _print_server_no_running: "Print Server Not Runing",
    _transfer_from: "Transfer From",
    _not_allow_mult_item_disc: "Cannot Set Item Discount When Multiple Items Are Selected!",
    _buildin_data_no_dele: "Built-In Data, Cannot Delete!",
    _printer_out_of_paper: "Is out of paper",
    _printer_open_door: "Has an open door",
    _inv_print_transfer_from: "Print Transfer From In Inv",
    _pay_slip_print_transfer_from: "Print Transfer From In Pay Slip",
    _slip_print_transfer_from: "Print Transfer From Slip",
    _copy_to_another_price_from_price1: "Copy To Another Price From Price1",
    _item_print_mode_item_set: "Set Item In 1 Slip",
    _slip_print_mode: "Order Slip Print Mode",
    _print_all: "Print All",
    _print_new_only: "Print New Only",
    _print_first_only: "Print First Only",
    _slip_print_Item_amount: "Print Prices on Order Slip",
    _slip_print_Item_code: "Print Item Code on Order Slip",
    _slip_print_include_modifier: "Print Modifiers on Order Slip",
    _slip_print_adduser: "Print User and Time on Order Slip",
    _slip_print_free_modifier: "Print Free (No Charge) Modifiers on Order Slip",
    _sitemsub_notallow_disc: "Set Items Cannot be Discounted!",
    _call_up: "Call Up",
    _slip_change: "Change",
    _slip_new: "Add",
    _print_now: "Now print",
    _order_ingredient_base: "Please Select An Ingredient!",
    _divided: "Divided",
    _hexadecimal: "Hexadecimal",
    _decimal: "Decimal",
    _uom_change_continue_save: "Uom Change, Will Affect Calculation,Are You Sure",
    _name_length_over_limited: "Name Exceeds Maximum Length",
    _kit_order_print_code: "Print Code on Kit Order",
    _order_entry_item_font_size: "Order Entry Item Font Size",
    _order_entry_modifier_font_size: "Order Entry Modifier Font Size",
    _outlet_not_found: "Outlet Not Found, Please Add A New Outlet!",
    _show_table_position_by_setting: "Show Table Position By Setting",
    _order_must_item: "Select Mandatory Order Items",
    _table_is_locked_by: "Table Is Locked By {0}",
    _refresh: "Refresh",
    _foreign_currency: "Foreign Currency",
    _domestic_currency: "Domestic Currency",
    _currency_type: "Currency Type",
    _cash: "Cash",
    _no_of_inv: "No. Of Invoice",
    _details: "Details",
    _paidlist: "Paid",
    _only_show_uncleaned: "(Show Non-Closed Amount Only)",
    _price_add: "Price Add",
    _price_breaks: "Price Breaks",
    _copy_to_another_price: "Copy To Another Price",
    _paid_invoice: "Paid Invoice",
    _custom_code_repeat: "Custom Code Repeat",
    _octopus_query: "Octopus Query",
    _item_available: "Available Item(s)",
    _item_details: "Item Details",
    _mincharge_diff: "Min Charge Difference",
    _minimum_rate_for_service_charge: "Minimum Rate for Service Charge",
    _choose: "Choose",
    _backup_when_clean: "Force Backup on Close-Out",
    _kitchen_order_dishes_language: "Kitchen Order Dishes Language",
    _kitchen_order_use_only: "Kitchen Order Use Only",
    _current_order_language: "Current Order Language",
    _inv_header: "Invoice Header",
    _inv_footer: "Invoice Footer",
    _proan_inside: "Proan Inside",
    _android_user_interface_setup: "Android User Interface Setup",
    _table_no_ppl: "Table/Guest(s)",
    _print_modifiers_additional_charges: "Print Modifiers With Additional Charges on Kitche",
    _print_free_modifiers: "Print Free (No Charge) Modifiers",
    _inv_print_0_amt_item: "Print $0 Amount Items",
    _print_set_meal_details: "Print Set Meal Details",
    _print_user_and_time_on_invoice: "Print User and Time on Invoice",
    _payway_rate_tip: "Set After The Effective Date, The Current Currency Convertible Cash, Such As Cash/ U.S. Dollars = 10/1, Or $1 Equivalent To $10 In Cash",
    _current_currency: "Current Currency",
    _discper: "Discount Rate (%)",
    _modifier_multiple_qty_whether_effective: "Modifier Multiple Qty Whether Effective",
    _is_active: "Active",
    _effective: "Effective",
    _bottom: "Last",
    _next: "Next",
    _prev: "Back",
    _top: "Top",
    _address_setup: "Address Setup",
    _address_list: "Address List",
    _area_code: "AreaCode",
    _area_setup: "Area Code Setup",
    _subarea_setup: "SubArea Setup",
    _hold: "Hold",
    _clean_input_tips: "Reminder to Enter Tips When Closing-Out",
    _paylist_print_itemcode: "Print Item Cocd on Payment Receipt",
    _period1: "Section 1",
    _period2: "Section 2",
    _period3: "Section 3",
    _order_by: "Order By",
    _opening_section: "Opening Section",
    _svc_charge: "Svc Charge",
    _order_only: "Order",
    _whether_to_continue: "Whether To Continu",
    _deshes_level: "Deshes Level",
    _setting_general: "General",
    _print_on_order_list: "Print On Order List",
    _set_background_image: "Set Background Image",
    _please: "Please",
    _selected: "Selected",
    _page_information_management: "Page information management",
    _page_maintenance: "Page Maintenance",
    _slip_print_mode_void_item: "Order Slip Item Cancellation Print Format",
    _complete_all_reprint: "Complete All Reprint",
    _phase: "Phase",
    _tower: "Block",
    _floor: "Floor",
    _room: "Room",
    _login_account: "Login Account",
    _alphanumeric_underline_input_only: "Alphanumeric Underline Input Only",
    _buildin_data_no_edit: "Built-In Data, Cannot Edit!",
    _historical_records: "Historical Records",
    _shop_qty: "Shop Qty",
    _sales_analysis: "Sales Analysis",
    _select_addr: "Please Select Address",
    _item_warning_mode: "Warning Mode When Item Qty Low",
    _not_prompt: "Not Prompt",
    _always_prompt: "Always Prompt",
    _set_by_item: "Set By Item",
    _qty_not_enough_continue: "Insufficient Qty, Order Anyway?",
    _item_warning_qty: "Warning When Item Qty Low",
    _allow_add_price_for_item_discount: "Allow Add Price For Item Discount",
    _no_sales_item: "Include Items With No Sales",
    _catery_dishes: "Catery + Dishes",
    _dept_dishes: "Dept + Dishes",
    _waiter_dept: "Waiter + Dept",
    _group_by: "Group By",
    _show_cost: "Show Cost",
    _show_daily: "Show Daily",
    _invalid_invcode: "Invalid Barcode, Please Input Again!",
    _barcode_wrong: "Barcode Error!",
    _order_done: "Order Has Been Void!",
    _order_paid: "Order Paid",
    _discount_round: "Discount+Round",
    _profit: "Profit",
    _margin: "Margin",
    _pages: "Pages",
    _belongdate: "Belong Date",
    _docno: "Doc No",
    _stock_take_option: "Stock Take Option",
    _part: "Section",
    _variance: "Variance",
    _takeqty: "Stock Take Qty",
    _aggregate: "Aggregate",
    _sales_analysis_section: "Sales Analysis-Section",
    _show_amt_type: "Show Amount",
    _daily_sales: "Daily Sales",
    _show_days_without_data: "Show Days Without Data",
    _show_rounding: "Show Rounding",
    _avginv: "Avg Rec",
    _department_daily_report: "Department Daily Report",
    _cost_percentage: "Cost Percentage",
    _committed_cannot_edit: "Edit Committed Document Does Not Allowed.",
    _delete_cannot_edit: "Edit Deleted Document Does Not Allowed!",
    _sto_belongdate: "Stock Take Date",
    _onhand: "On Hand Qty",
    _variance_cost: "Variance Unit Cost",
    _cmd_stocktake: "Stock Take",
    _seq_no: "Seq. No.",
    _Atte_Cut_time: "Atte. Cut Time",
    _attendance_cam: "Attendance Cam",
    _attendance_range_count: "Attendance Range Count",
    _function_introduction: "Function introduction",
    _dishes_composition_setting: "Dishes Composition Setting",
    _picture: "Picture",
    _caption: "Caption",
    _please_select_department: "Please Select Department",
    _signinout: "Sign In/Out",
    _period: "Period",
    _sign_in: "Sign In",
    _sign_out: "Sign Out",
    _whether_to_clean_up_qty_every_day: "Whether To Clean Up Qty Every Day",
    _not_commit_no: "A Stock Take Count Sheet Does Not Commit Is：",
    _detail: "Detail",
    _display: "Display",
    _summary: "Summary",
    _income_analysis: "Income+Analysis",
    _unclassified: "Unclassified",
    _item_qty_per_day: "Item Qty Per Day",
    _best_worst_selling: "Best / Worst Selling",
    _rank: "Rank",
    _hour: "Hour",
    _daily_and_hour: "Daily And Hour",
    _update_modifier_qty_match_item_qty_changes: "Update Modifier Qty to Match Item Qty Changes(Multiple Qty Not Effective)",
    _checkout_time: "Checkout Time",
    _best: "Best",
    _worst: "Worst",
    _count: "Count",
    _money: "Money",
    _species_group_show: "Species Group Show",
    _show_deleted: "Show Deleted Record(s)",
    _copy_from_other_shop: "Copy From Other Shop",
    _number: "Number",
    _picture_maintenance: "Picture maintenance",
    _subcate_dishes: "Subcate + Dishes",
    _brand_dishes: "Brand + Dishes",
    _vendor_dishes: "Vendor + Dishes",
    _change_item_price: "Change_item_price",
    _inv_no: "Invoice Number",
    _table_useage_analysis: "Table Useage Analysis",
    _group_show: "Group Show",
    _by: "By",
    _sign: "Sign",
    _pay_off_line: "Pay Off Line",
    _member_no: "Member No.",
    _member_name: "Member Name",
    _member_tel: "Member Telephone",
    _point_rule: "Point Rule",
    _member_maintenance: "Member Maintenance",
    _table_section_analysis: "Table Section Analysis",
    _modifier_report: "Modifier Report",
    _paid_in: "Paid-in",
    _discount_percentage: "Discount Percentage",
    _special_discount_percentage: "Special Discount Percentage",
    _calc_method: "Calc. Method",
    _discount_report: "Discount Report",
    _mail_addr: "Mail Address",
    _eng_name: "English Name",
    _chi_name: "Chinese Name",
    _mobile_phone: "Mobile Phone",
    _homepage: "Web Site",
    _job: "Occupation",
    _id_no: "I.d. No",
    _birthday: "Date Of Birth",
    _join_shop: "Join Shop",
    _inv_count: "Purchase Times",
    _current_points: "Current Point",
    _inv_amount: "Purchase Amt",
    _gender: "Gender",
    _residential: "Residential",
    _male: "Male",
    _female: "Female",
    _lbl_yyyymmdd: "(yyyy/mm/dd)",
    _inv_input_member_show_message_1: "After Input Or Cancel Member",
    _inv_input_member_show_message_2: "System Will Re-calc The Item Price",
    _points_to_redeem: "Points To Redeem",
    _point: "Points",
    _normal_calculation: "Normal Calculation",
    _round_to_2_decimal: "Round To 2 Decimal",
    _round_to_1_decimal: "Round To 1 Decimal",
    _round_to_integer: "Round To Integer",
    _up_to_integer: "Up To Integer",
    _down_to_integer: "Down To Integer",
    _date_last: "End Date",
    _can_edit_price_now: "Allow Price Change",
    _redeem_to_integer: "Redeem To Integer",
    _move_item: "Move Item",
    _company_name: "Company Name",
    _show_multi_unit_on_kitchen: "Show Multi Unit Name On Kitchen List",
    _show_multi_unit_on_slip: "Show Multi Unit Name On Slip",
    _show_quick_payment_qr_code: "Show Quick Payment QR Code",
    _kit_callup: "Kit Call Up",
    _tel_addr: "Tel/Addr",
    _eng_chi_name: "Eng/Chi Name",
    _code_or_email: "Code Or Email",
    _qty_range: "Qty Range",
    _payslip_printer: "Payment Receipt Printer",
    _already_add: "Already Add",
    _already_success: "Already Success",
    _recipe_already_exist: "Recipe Already Exist",
    _onhand_qty: "OnHand Qty",
    _take_qty: "Take Qty",
    _approve: "Approve",
    _link_man: "Link  Man",
    _voided_items: "Voided Items",
    _unselect: "Unselect",
    _member_list: "Member List",
    _circle: "Round",
    _not_to_print: "Not to print",
    _register: "Register",
    _registered: "Registered",
    _not_registered: "Sorry, You Are Not Registered",
    _sex: "Sex",
    _code_name: "Code/Name",
    current_printer_is_already_in_use: "Current Printer Is Already In Use,Are You Sure",
    "_member/member_type": "Member/Member Type",
    _no_printer_found: "No Printer Found",
    _show_each_shop: "Show Each Branch",
    _qty_not_enough: "Insufficient Qty!",
    _whether_server: "Whether Server",
    _amount_number: "Amount Number",
    _whether_talking_caller: "Whether Talking Caller",
    _regular_discount_percentage: "Regular Discount Percentage",
    _waiting: "Waiting",
    _period4: "Section 4",
    _period5: "Section 5",
    _show_multi_unit_on_invoice: "Show Multi Unit Name On Invoice",
    _show_multi_unit_on_pay_slip: "Show Multi Unit Name On Pay Slip",
    _item_data: "Item Data",
    _qty_remain: "Qty Remain",
    _item_no_range: "Item Number Range",
    _sold_out_dishes: "Sold Out Dishes",
    _not_show_in_order: "Not Show In Order",
    _do_clean_confirm: "Are You Sure You Want To Close Out?",
    _inv_checked: "Closing Completed!",
    _material_list: "Material List",
    _vendor_list: "Vendor List",
    _section1: "Section1",
    _section2: "Section2",
    _section3: "Section3",
    _section4: "Section4",
    _section5: "Section5",
    _print_modifier_prices: "Print Modifier Prices",
    _item_id: "Item Code",
    _point_used: "Points Used",
    _points_remain: "Remaining Points",
    _day: "Day",
    _month: "Month",
    _print_modi_same_line: "Print Modi Same Line",
    _print_item_modi_sale_line: "Print Item Modi Sale Line",
    _inv_print_void_item: "Print Cancelled Items on Invoice",
    _take_away_address: "Takeout address",
    _set_min_charge: "Set Min Charge",
    _print_pay_slip_fastfood: "Fastfood Print Payment Receipt",
    _sys_user_list: "User information",
    _invoice_print: "Dine in Print Invoice",
    _member_group_show: "member group show",
    _sitem_print_shell: "Print Set Meal (Combo) Name",
    _print_all_after_completion: "Print All After Completion ",
    _soldout_setup: "Soldout Item Message Setup",
    _service_charge: "Service Charge",
    _inv_print_table_name: "Print Table Name On Invoice",
    _more_to_min_currency_unit: "More To Min Currency Unit",
    _less_to_min_currency_unit: "Less To Min Currency Unit",
    _round_to_min_currency_unit: "Round To Min Currency Unit",
    _computer_name: "Compute Name",
    _income: "Income",
    _analysis: "Analysis",
    _selected_item: "Selected Item",
    _annual_business_report: "Annual Business Report",
    _select_please_: "Please Select {0}",
    _show_modi: "Show modifier",
    _effective_outlet: "Effective Outlet",
    _month_total: "Month Total",
    _days_total: "Days Total",
    _average_daily: "Average Daily",
    _year_total: "Year Total",
    _year_days_accumulate: "Year Days Accumulate",
    _year_average: "Year Average",
    _jan: "Jan",
    _feb: "Feb",
    _mar: "Mar",
    _apr: "Apr",
    _may: "May",
    _jun: "Jun",
    _jul: "Jul",
    _aug: "Aug",
    _sep: "Sep",
    _oct: "Oct",
    _nov: "Nov",
    _dec: "Dec",
    _no_same_outlet: "Different business areas,Continue?",
    _allow_all_price_book: "Allow All Price Book",
    _exist_same_addr: "Exist Same Address Name.",
    _allow_all_disc_pricebook: "Allow All Discount Pricebook",
    _allow_pricebook: "Allow All Discount Pricebook",
    _include_station: "Include Station",
    _member_sales_analysis: "Member Sales Analysis",
    _pet_age: "Age",
    _pet_type: "Pet Type",
    _one_year_amount: "One Year Pur-Amt",
    _wrist: "Wrist",
    _setup_mode: "Setup Mode",
    _exclude_holiday: "Exclude Holiday",
    _sales_price: "Sales Price",
    _please_input_name: "Please Input Name",
    _invoice_descending: "Invoice No.(Descending Order)",
    _invoice_ascending: "Invoice No.(Ascending Order)",
    _tableno_descending: "Table No.(Descending Order)",
    _tableno_ascending: "Table No.(Ascending Order)",
    _amount_descending: "Sales Amount(Descending Order)",
    _amount_ascending: "Sales Amount(Ascending Order)",
    _join_qty_or_spin_off: "Join Qty Or Spin Off",
    _not_handling: "Not Handling",
    _join_qty_when_same_item: "Join Qty When Same Item",
    _mult_order_item_break: "Mult Order Item Break",
    _can_not_re_add_to_menu: "Can not repeat add to the menu",
    _schedule_price: "Schedule Price",
    _price_fastfood: "Take Away Price",
    _sale_period: "Selling Only In Section",
    _calc_with_org_srv: "Calc Service Fee Based on Original Price",
    _project: "Project",
    _custom_section: "Custom Section",
    _tax_setup: "Tax Setup",
    _remin_reason_setup: "Remin Reason Setup",
    _reason_for_press_alarm: "Setup Reason for Press the Alarm",
    _fastfood_message_setup: "Take Away Message Setup",
    _auto_disc_setup: "Auto Discount Setup",
    _dine_active: "Dine-In Active",
    _fastfood_active: "Fastfood Active",
    _barcode_active: "Barcode Active",
    _barcode: "Barcode",
    _barcode_check_out: "Barcode Check-Out",
    _order_langue: "Order Interface Language",
    _year_repeat: "Recurring Yearly",
    _receipt_remark: "Receipt Remark",
    _charge_type: "Tender Change",
    _change_return: "Change",
    _change_inre: "Ignore",
    _change_tips: "As Tips",
    _currency_ratio: "Unit of Currency Ratio",
    _is_input_creditcardno: "Require Credit Card No.",
    _lms_recharge: "Lms Recharge",
    _pay_type: "Pax type",
    _none: "None",
    _swipe_card: "Swipe Card",
    _quick_pass: "Quick Pass",
    _both: "Both",
    _is_cash_coupon: "Is A Coupon",
    _cash_coupon_value: "Coupon Value",
    _bo_cash_coupon_date_startth: "Coupon Start Date",
    _cash_coupon_date_last: "Coupon End Date",
    _print_other_lanaguage: "Do you want to print other languages(if exist)?",
    _auto_backup: "Auto System backup",
    _linkserver: "LINKSERVER",
    _default_language: "Default Language",
    _table_page: "Table Page",
    _allow_signinout: "Allow Sign In/Out",
    _allow_invoice: "Allow Receipt Settlement",
    _has_drawer: "Cash Drawer",
    _port_no: "Port No.",
    _has_port: "Cash Drawer COM Port",
    _pole_display: "Pole Display",
    _pole_display_message: "Pole Display Message",
    _self_order_tableno: "Self Order Tableno",
    _having_card_reader: "Having Card Reader",
    _queuing_machine: "Queuing Machine",
    _calc_with_tael: "Calc With Tael",
    _kit_print_attention: "Attention Please, Please do not use the last one if the print is incomplete",
    _backcolor: "Background Color",
    _no_check_out_when_zero: "No Check Out When Zero",
    _add_log: "Do you want to add logs",
    _free_amount_by_order: "Complimentary Amount Per Order",
    _auto_order: "Auto Return to Order Screen",
    _auto_lout: "Auto Lout",
    _auto_lout_return_main: "Auto lout back to the Main",
    _no_operate: "Seconds Before Auto Lout",
    _info_can_view: "Sales History Can View",
    _password_card_dbl_check: "Password And Card Double Check",
    _minute: "Minutes",
    _no_print: "Do No Print",
    _no_print_when_zero: "Do No Print When Zero",
    _material_cate: "Material Catery",
    _menu_manage: "Menu Manage",
    _item_manage: "Item Manage",
    _item_maintenance: "Item Maintenance",
    _default_disc: "Default Discount",
    _select_classification: "Select Classification",
    _advanced_administrator: "Advanced Administrator",
    _fastfood: "Take Away",
    _askprice: "Floating Price",
    _sync_order_dine: "Sync Order Dine",
    _please_select_at_least_one_item: "Please Select At Least One Item",
    _please_select_at_least_one_modi_cate: "Please Select At Least One Modi Cate",
    _item_modi_batch: "Item Modi Batch",
    _item_modi_batch_update: "Item Modi Batch Update",
    _item_modi_batch_add: "Item Modi Batch Add",
    _item_modi_batch_delete: "Item Modi Batch Delete",
    _not_add_if_exist: "Not Add If Exist",
    _only_add: "Only Add",
    _if_exist_the_same_modi_cate_not_add: "If Exist The Same Modi Cate Not Add",
    _if_exist_the_same_modi_cate_replace_must_item_and_add_corresponding_quantity: "If Exist The Same Modi Cate Replace Must Item And Add Corresponding Quantity",
    _item_printer_batch: "Item Printer Batch",
    _item_printer_batch_update: "Item Printer Batch Update",
    _item_printer_batch_add: "Item Printer Batch Add",
    _item_printer_batch_delete: "Item Printer Batch Delete",
    _please_select_at_least_one_printer: "Please Select At Least One Printer",
    _category: "Category",
    _categories: "Categories",
    _item_rule: "Item Rule",
    _original_price: "Original Price",
    _original_price_fastfood: "Fastfood Original Price",
    _copy_color_to_items_with_same_category: "Copy Color To Items With Same Category",
    _if_exist_the_same_modi_cate_replace_must_item: "If Exist The Same Modi Cate Replace Must Item",
    _auto_logout: "Auto Logout",
    _auto_logout_return_main: "Auto logout back to the Main",
    _show_password: "Show Password",
    _levelA: "LevelA",
    _levelB: "LevelB",
    _disc_sys_user_can_not_more_than: "Disc User Can Not More Than {0}",
    _disc_sys_user_more_than_size: "Disc User More Than Size",
    _sure_to_add_all_entry: "Sure To Add All Entry",
    _not_allow_more_than_char: "Not Allow More Than {0} Char",
    _current_printer_is_already_in_use: "Current Printer Is Already In Use,Are You Sure",
    _item_code_or_barcode_exist_not_repeat: "Item Code Or Barcode Exist Not Repeat",
    _selforder_item_modi: "Self Order Item Modi",
    _shop_count: "Shop Count",
    _can_select: "Can Select",
    _term: "Term",
    _can_repeat_select: "Can Repeat Select",
    _order_interface_info: "Order Interface Info",
    _item_info: "Item Info",
    _repeat_not_allow_recall: "Repeat Not Allow Recall",
    _cut_order_min: "Cut Order Min",
    _sit_in_min: "Sit In Min",
    _item_cut_order: "Item Cut Order",
    _cut_order_min_can_not_longer_than_sit_in_min: "Cut Order Min Can Not Longer Than Sit In Min",
    _active_section_apply_to_active_dishes_cate: "Active Section Apply To Active Dishes Cate",
    _not_allow_delete: "Not Allow Delete",
    _upgrade_item: "Upgrade Item",
    _belong_to_item_list: "Belong To Item List",
    _not_sync_order: "Not Sync Order",
    _station_apply_to_active_dishes_cate: "Station Apply To Active Dishes Cate",
    _station_apply_to_system_setting: "Station Apply To System Setting",
    _percent: "Percent",
    _please_set_price_first: "Please Set Price First",
    _so_disc: "SelfOrder Hall Discount",
    _so_disc_amt: "SelfOrder Hall Discount Amount",
    _so_disc_perc: "SelfOrder Hall Discount Percent",
    _so_disc1: "SelfOrder Takeaway Discount",
    _so_disc_amt1: "SelfOrder Takeaway Discount Amount",
    _so_disc_perc1: "SelfOrder Takeaway Discount Percent",
    _so_print_slip: "SelfOrder Print Slip",
    _so_printer: "SelfOrder Printer",
    _total_price_of_all_departments_must_equal_to_price: "Total Price Of All Departments Must Equal To Price",
    _whether_add_to_menu: "Whether Add To Menu",
    _whether_pop_join_menu_next_time: "Whether Pop Join Menu Next Time",
    _join_menu: "Join Menu",
    _multi_item_must_include_an_item: "Multi Item Must Include An Item",
    _inventory_management: "inventory management",
    _stock_report: "Stock Report",
    _stock: "Stock",
    _allow_sell: "Allow Sell",
    _not_allow: "Not Allow",
    _advanced: "Advanced",
    _tot_cost: "Total Cost",
    _compose_type: "Compose Type",
    _and: "And",
    _custom_goods: "Custom Goods",
    _custom_price: "Custom Price",
    _custom_fastfood_price: "Custom Fastfood Price",
    _copy_to_fastfood_price_from_price: "Copy To Fastfood Price From Price",
    _upgrade_multi_qty: "Upgrade Multi Qty",
    _po_packing_fee_add: "Po Packing Fee Add",
    _po_plastic_bag_fee_add: "Po Plastic Bag Fee Add",
    _pot_packing_fee_add: "Pot Packing Fee Add",
    _pot_plastic_bag_fee_add: "Pot Plastic Bag Fee Add",
    _po_delivery_fee_add: "Po Delivery Fee Add",
    _single_po_plastic_bag_fee: "Single Po Plastic Bag Fee",
    _single_pot_plastic_bag_fee: "Single Pot Plastic Bag Fee",
    _po_plastic_bag_fee_add_perc: "Po Plastic Bag Fee Add Perc",
    _pot_plastic_bag_fee_add_perc: "Pot Plastic Bag Fee Add Perc",
    _category_dishes: "Category + Dishes",
    _sales_report: "Sales Report",
    _brow_level_item_in: "Browse Items in Deshes Level({0})",
    _no_ask_remark: "No Ask Remark",
    _must_input_remark: "Must Input Remark",
    _ask_remark_can_empty: "Ask Remark,Can Empty",
    _whether_ask_remark: "Whether Ask Remark",
    _so_qr_order_count: "So QRCode Order Count",
    _so_tables_count_plus_ppl: "So Tables Count Plus Ppl",
    _limit_when_click: "Limit When Click",
    _check_when_submit: "Check When Submit",
    _total_quantity_may_exceed_the_limit_quantity: "Total Quantity May Exceed The Limit Quantity",
    _price_limit_prompt_a_quantity_limit_for_dishes: "Strictly limited, it will clearly prompt the user that the number of dishes is limited",
    _extra_pointrate: "Extra Pointrate",
    _extra_pointfix: "Extra Pointfix",
    _points_needed: "Points Needed",
    _timing: "Timing",
    _is_timer_item: "Is Timer Item",
    _calculated_from_seating_time: "Calculated From Seating Time",
    _according_to_adding_dishes_time: "According To Adding Dishes Time",
    _how_many_minutes_a_section: "How Many Minutes A Section",
    _timer_level_price: "Timer Level {0} Price",
    _wechat_pay: "Wechat Pay",
    _alipay: "Alipay",
    _uepay: "UePay Wallet",
    _china: "China",
    _hk: "HK",
    _use_previous_section_price_plus_sell_price_if_zero_for_section_price: "Use Previous Section Price Plus Sell Price If Zero For Section Price",
    _price_of_first_X_period_cannot_be_all_zero: "The Price Of The First X Period Cannot Be All Zero",
    _add_one: "Add One",
    _minus_one: "Minus One",
    _tip: "Tip",
    _paymethod: "Pay Method",
    _simplify: "Simplify",
    _daily_turnover: "Daily Turnover",
    _inv_no_range: "Inv No. Range",
    _seat_time: "Seat Time",
    _inv: "Inv",
    _disc: "Disc",
    _include_srv: "Include Srv",
    _display_modi: "Display special treatment",
    _date_cannot_cross_month: "Date cannot cross month",
    _date_not_found: "Sorry! Data not found",
    _dish_daily_quantity: "Daily quantity of dishes",
    _category_pay_excel: "Category Pay (Excel)",
    _show_each_item: "Show Each Item",
    _report_date_not_allow_more_than_day: "Report Date Not Allow More Than {0} Day",
    _services: "Services",
    _sun: "SUN",
    _mon: "MON",
    _tue: "TUE",
    _wed: "WED",
    _thu: "THU",
    _fri: "FRI",
    _sat: "SAT",
    _rev_sales_byday: "Review Sales By Day",
    _Self_help: "Self help",
    _Customs: "Customs",
    _Custom_Business_Hours: "Custom Business Hours",
    _Business_Hours: "Business Hours",
    _self_hours_areas: "Self-service hours",
    _Only_QrCode_orders: "Only applicable to QrCode orders",
    _Sales_induction_department: "Sales induction department",
    _default_cup: "tea mustard",
    _General_settings: "General settings",
    _srv_tran: "time service fee",
    _calc_type: "calculation mode",
    _Calculated_dishe: "Calculated according to the time of adding dishes",
    _Calculated_seat: "Calculated by seat time",
    _srv_name: "Steering service fee",
    _start_date: "start date",
    _end_date: "end date",
    _srv_tran_start_time: "daily start time",
    _srv_tran_end_time: "daily end time",
    _turn: "turn",
    _srv_tran_empty: "Steering service fee cannot be empty",
    _ex_festival: "Except festival",
    _srv_tran_sort: "At least 2 rows of data in ascending or descending order",
    _srv_tran_sort_save_tip: "The currently selected row data is not saved, please select another row to reorder",
    _linkserver_backup: "Responsible for order data backup",
    _pole_display_silver: "silver code display",
    _pole_message_silver: "Silver Code Display Information",
    _unit_swap: "unit swap",
    _Invoice_cn: "Invoice (Chinese name)",
    _Invoice_en: "Invoice (English name)",
    _Is_it_allow: "Is it allowed",
    _required_item_check: "Required items (check when printing the order)",
    _order_interface_info_cn: "Introduction to Chinese ordering interface(self-service ordering)",
    _item_info_self_cn: "Chinese food information (self-service order)",
    _order_interface_info_en: "Introduction to the English ordering interface (self-service ordering)",
    _item_info_self_en: "English menu information (self-service order)",
    _ask_dept: "instant payment",
    _modi_dept_after_inv: "Modify billing after checkout",
    _print_kit: "Print Kit",
    _total_customer: "Total customer",
    _total_invoice_quantity: "Total invoice quantity",
    _amount_per_guest: "Amount Per Guest",
    _amount_per_order: "Amount Per Order",
    _dine_in_amount: "Dine-In Amount",
    _dine_in_inv_qty: "Dine-In invoice quantity",
    _five_best_selling: "Five Best selling",
    _total_sales_amount: "Total sales amount",
    _operation_log: "Operation log",
    _already_printed: "Already printed",
    _no_printed: "No printed",
    _comparison_report_section: "Comparison report(section)",
    _outlet_amount: "Outlet Amount",
    _discount_name: "Discount Name",
    _calc_mode: "Calc Mode",
    _meal_time: "Meal Time",
    _common_timing: "Common Timing",
    _each_time_add: "Each Time Add",
    _time_related_ppl: "Time Related to People",
    _display_in_selforder: "Display In Self Order",
    _print_order_slip: "Print Slip",
    _print_pay_list: "Print Pay List",
    _menu_options: "Menu options",
    _add_type: "Add Type",
    _unlimit_qty: "Unlimited Quantity",
    _total_qty: "Total Quantity",
    _each_item_qty: "Each Item Quantity",
    _add_total_qty: "Add Total Qty",
    _add_qty: "Add Qty",
    _add_qty_upper: "Qty Upper",
    _include_item: "Include Item",
    _each_item_qty_not_zero: "Each Item Quantity, Quantity Cannot Zero",
    _method: "Method",
    _add_qty_upper_zero_info: "Quantity upper zero, will no limited",
    _disc_mm: "mm",
    _distribute_item: "Distribute Item",
    _self_order_remark: "Self Order Remark",
    _deleted: "Deleted",
    _so_qr_order_count_ppl: "So QRCode Order Count Ppl",
    _so_tables_count_plus_ppl_everyone: "So Tables Count Plus Ppl Everyone",
    _show_sitem_name: "Show Sitem Name",
    _section_price_cate_cannot_empty: "Applicable category of period selling price cannot be empty",
    _edit_custom_section_shall_prevail: "For all stores, if user-defined time period is modified, the time period shall prevail",
    _sync_foodpanda: "Sync foodpanda",
    _unid_cost: "Unit cost",
    _incorrect_shop_price_section: "Incorrect period selling price: when all shop set to sell within the period, the user-defined time should be modified",
    _applicable_cate: "Applicable Category",
    _same_cost_as_dishes: "Same cost as dishes",
    _custom_cost: "Custom cost",
    _foodpanda_add_rate: "Foodpanda Add Rate",
    _foodpanda_add_rounding: "Foodpanda Add Rounding",
    _foodpanda_add_rounding1: "Less to Dollar",
    _foodpanda_add_rounding2: "Down to 10 Cents",
    _allow_kb_ord: "Allow When Keyboard Ordering",
    _sales_category: "Sales category",
    _must_modi_select_all: "must modifier,select all",
    _classification: "Classification",
    _channel: "Channel",
    _so_tables_count_plus_ppl_active: "number of passengers",
    _effective_section_detail: "Details of effective business hours",
    _schedule_price_plan_detail: "Time period selling price plan details",
    _schedule_price_shop_detail: "Branch price details",
    _cost_type: "Follow dish cost/custom cost",
    _void_user: "Operator",
    _net_amt: "Payment",
    _void_user_title: "user",
    _enter_mode: "enter mode",
    _ask_dept_confirm: "Discounts for this dish will not be possible with instant department split enabled, do you want to continue?",
    _modi_dept_after_inv_confirm: "After checkout is enabled, it will not be possible to make a discount for this dish. Do you want to continue?",
    _operation_record: "Operation record",
    _accident_record: "accident record",
    _octopus_record: "Octopus record",
    _change_price_record: "Change price record",
    _turntable_record: "Turntable record",
    _goods_exchange_record: "Goods exchange record",
    _worst_selling: "Worst selling",
    _best_sales: "Best sales",
    _worst_selling_amount: "Worst selling amount",
    _worst_selling_quantity: "Worst selling quantity",
    _best_sales_amount: "Best sales amount",
    _best_sales_quantity: "Best sales quantity",
    _comparison_type: "Comparison type",
    _turnover_during_business_hours: "Turnover during business hours",
    _wechat_report: "Wechat Report",
    _departmental_turnover: "Departmental turnover",
    _qrcode_remind_mins: "How many minutes does it take for a self-service order to be tracked?",
    _qrcode_remind_mins_tip: "0 means not chasing orders",
    _shop_tableno_tip: "Branch and station number cannot be empty",
    _show_in_cup_mode: "Change the quantity on the tea mustard page",
    _focus_item: "Focus on dishes",
    _by_entity_for_calc_qty: "Calculate the quantity according to the whole article (report and sold out)",
    _include_all_cate: "(* = including all cate) ",
    _festival: "festival",
    _exclude_festival: "Except festival",
    _set_sub_item_sold_out: "Set Item dcalculate dishes sold out remainder",
    _dine_in_detail: "Seating details",
    _order_invoice_list: "List of invoices",
    _local_print_kit: "Print kitchen list locally",
    _qr_android_local_kit_printer_id: "Kitchen single printer (Qrcode, for Android local printing dishes)",
    _dine_in: "Dine In",
    _restaurant_turnover: "Restaurant turnover (disaster recovery)",
    _is_itemdept: "Whether to participate in the split",
    _departments_price_can_not_zero: "Item Department Price Cannot Be Zero",
    _view_user_password: "View User Password",
    _proan_wechat_user: "WeChat authorized associated users",
    _user_code: "User ID",
    _own_role: "Own role",
    _deleted_user: "The original bound user has been deleted",
    _user_instructions: "User ID code acquisition instructions",
    _attention_public: "Scan the code and follow the WeChat public account",
    _click_setting_center: "Enter our WeChat official account, click [Settings Center]",
    _see_personal_information: "Enter the settings center page, you can see the user identification code below the personal information",
    _no_matches_found: "No matches found",
    _only_digits: "Can only be {0} digits",
    _max_effective_users: "Max number of effective users",
    _number_remaining_users: "Number of remaining users",
    _due_date_wechat_Report: "Due date of wechat Report",
    _lookup_shop_list: "Include branch, branch group, exclude branch select at least one",
    _maximum_number_valid_users_exceeded: "maximum number of valid users has been exceeded",
    _calc_time_by: "By current time",
    _calc_time_by_current: "By current time",
    _calc_time_by_seat: "By seating time",
    _input_maxlength: "Input length cannot exceed {0} characters",
    _new_start_time: "Start time of day",
    _new_end_time: "End of day",
    _calc_time_by_title: "Display method",
    _wechat_sys_user_row: "Tip: There are currently {0} user data displayed, you can use the search function",
    _end_date_to: "Date To",
    _start_date_to: "Date by",
    _date_from_new: "Date From",
    _date_to_new: "Date To",
    _visitor_analysis: "Visitor analysis",
    _daily_avg_report: "Daily avg report",
    _add_time: "Upload time",
    _shop_tip: "Branch cannot be empty",
    _attendance_report: "Attendance report",
    _employee_date: "Employee + date",
    _date_employee: "Date + employee",
    _show_user_id: "Show user id",
    _work_hours: "Working hours",
    _multi_choise_for_proan: "Most choice",
    _must_choise_for_proan: "It takes effect when special treatment is required",
    _min_choise_for_proan: "At least choose",
    _print_limit: "A station number must be selected to allow printing",
    _print_all_tip: "Currently no print data",
    _print_search_tip: "Reminder: station number is not required",
    _print_all_report: "Print all",
    _print_report: "Print",
    _must_select_modi: "Required When special treatment, must choose",
    _case_mat_multiple: "Example",
    _case_mat: "Mat",
    _case_mat_tip: "(0 is not a case/seat)",
    _color_desc: "Color description",
    _blank_table: "Blank table",
    _ever_printed: "Ever printed",
    _other: "Other",
    _qr_min_order_qty: "Minimum order quantity for automatic ordering",
    _is_cashier: "Cashier",
    _monthly_turnover: "Monthly turnover",
    _system_name: 'Proan',
    _switch_language: 'Switch language successfully',
    _theme_switching: "Theme switching",
    _full_screen:"Full screen",
    _language_label: "Language",
    _account: "Account",
    _login_title:"Pro-an Computer Rms-Mis",
    _input_code:"Please enter the code",
    _input_name:"Please enter a name",
    _cancel_dekete:"Cancelled deletion",
    _shop_new: "Shop[New]",
    _shop_edit: "Shop[Edit]",
    _select_please_input:"---Please Select---",
    _saveing:"Saving..",
    _select_please_section: "Please select a time period",
    _empty_Tips:"The required information is incomplete, please check!",
    _font_size:"Font size",
    _switch_size: 'Successfully switched font size',
    _small:"Small",
    _medium: "Medium",
    _big:"Big",
    _input_account:"Please enter the account",
    _input_password:"Please enter the password",
    _logining:"Logging in..",
    _station_new:"Station[New]",
    _station_edit: "Station[Edit]",
    _input_station_name:"Please enter station name",
    _select_shop:"Please select shop",
    _back_top: "Back to top",
    _back_bottom:"Back to bottom",
};
export default en;
